import React, { useState } from "react";
import { Button, Modal, Select, Skeleton, Text } from "@nimbus-ds/components";
import { CommonBaseProps } from "./types.d";
import { FormattedMessage, useIntl } from "react-intl";

interface CustomModalProps {
  sizeGuides: CommonBaseProps[] | undefined;
  fitTypes: CommonBaseProps[] | undefined;
  // selectedRows: any[] | [],
  updateRows: (selectedSizeGuideId: any, selectedFitTypeId: any) => void;
}

const CustomModal: React.FC<CustomModalProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSizeGuideId, setselectedSizeGuideId] = useState<any>();
  const [selectedFitTypeId, setselectedFitTypeId] = useState<any>();

  const intl = useIntl(); // Initialize useIntl hook
  const modalTitle = intl.formatMessage({
    id: "modal.modifyProducts",
    defaultMessage: "Modificar productos",
  });

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleConfirm = () => {
    // const updatedRows = props.selectedRows.map((row: any) => ({
    //   ...row,
    //   guideNumber: selectedSizeGuideId,
    //   fit: selectedFitTypeId,
    // }));
    props.updateRows(selectedSizeGuideId, selectedFitTypeId); // Call the updateRows function with selected guide number and fit
    closeModal();
  };

  return (
    <div>
      <Button onClick={openModal}>
        <FormattedMessage id="text.modify" defaultMessage=" Modificar" />
      </Button>
      <Modal open={isOpen} onDismiss={closeModal}>
        <Modal.Header title={modalTitle} />{" "}
        {/* Pass the formatted string here */}
        <Modal.Body padding="none">
          <Text textAlign="left">
            <FormattedMessage
              id="text.modifyproducts"
              defaultMessage="Aqui podrás modificar todos los productos seleccionados que tengan
            la misma guía de talles y fit."
            />
          </Text>
          <div className="custommodal-select-container">
            <div className="custommodal-column-container">
              <Text textAlign="left">
                <FormattedMessage
                  id="sizeGuides"
                  defaultMessage="Guía de Talles"
                />
              </Text>
              {props.sizeGuides === undefined || props.sizeGuides === null ? (
                <>
                  <Skeleton height="1.8rem" width="9rem" borderRadius="2" />
                </>
              ) : (
                <>
                  <Select
                    appearance="neutral"
                    id={`guideNumber-select`}
                    name={`guideNumber`}
                    value={selectedSizeGuideId}
                    onChange={(e) => setselectedSizeGuideId(e.target.value)}
                  >
                    {/* Render your options based on RsProductProps */}
                    <Select.Option label=".." value="0" />
                    {props.sizeGuides.map((sizeguide) => (
                      <Select.Option
                        key={sizeguide.Id}
                        label={sizeguide.Name}
                        value={`${sizeguide.Id}`}
                      />
                    ))}
                  </Select>
                </>
              )}
            </div>
            <div className="custommodal-column-container">
              <Text textAlign="left">
                <FormattedMessage id="col.fit" defaultMessage="Calce" />
              </Text>
              {!props.fitTypes ? (
                <>
                  <Skeleton height="1.8rem" width="9rem" borderRadius="2" />
                </>
              ) : (
                <>
                  <Select
                    appearance="neutral"
                    id={`fit-select`}
                    name={`fit`}
                    value={selectedFitTypeId} // Example: Access FitType's Name property
                    // defaultValue={row.FitType.Id}
                    onChange={(e) => setselectedFitTypeId(e.target.value)}
                  >
                    <Select.Option label=".." value="0" />
                    {props.fitTypes.map((fit) => {
                      return (
                        <>
                          <Select.Option label={fit.Name} value={`${fit.Id}`} />
                        </>
                      );
                    })}
                  </Select>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button appearance="neutral" onClick={closeModal}>
            <FormattedMessage id="cancelButton" defaultMessage="Cancelar" />
          </Button>
          <Button appearance="primary" onClick={handleConfirm}>
            <FormattedMessage id="confirmButton" defaultMessage="Confirmar" />
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CustomModal;
